<template>
	<popup-system v-bind="{ systemId, system }" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import PopupSystem from '@/common/popup/components/PopupSystem.vue';

import { ToastSystem } from '../ToastSystem';

export default defineComponent({
	components: {
		PopupSystem,
	},

	setup() {
		const system = ToastSystem.instance;

		return {
			system,

			systemId: ToastSystem.systemId,
		};
	},
});
</script>

<style lang="scss"></style>
